import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import videoService from '~/services/videoService';
import Index from '~/pages/Index';
import { useProfile } from '~/hooks/profile';

// import NavigationVideo from './NavigationVideo';
import Loading from '~/components/Loading';
import MovieRow from './MovieRow';
import FeaturedVideo from './FeaturedVideo';

import * as S from './styles';

const EM_BREVE_PATH = '/dashboard/tutoriais/video/em-breve';

export default function Tutoriais() {
  const navigate = useNavigate();
  const { profileComplete, loading: profileLoading } = useProfile();
  const [movieList, setMovieList] = useState([]);
  const [featuredData, setfeaturedData] = useState(null);

  useEffect(() => {
    if (profileLoading) return;

    // Cadastro incompleto: mesma experiência de quem ainda não tem vídeos
    if (!profileComplete) {
      navigate(EM_BREVE_PATH);
      return;
    }

    const loadAll = async () => {
      try {
        // Pegando a lista total
        const list = await videoService.getKnowList();
        const results = list[0]?.items?.results;
        if (!results?.length) {
          return navigate(EM_BREVE_PATH);
        }
        setMovieList(list);

        // Pegando o Featured
        const popularity = list.filter(i => i.slug === 'popularity');
        const popularityResults = popularity[0]?.items?.results;
        if (!popularityResults?.length) {
          return navigate(EM_BREVE_PATH);
        }
        const randomChosen = Math.floor(
          Math.random() * (popularityResults.length - 1)
        );
        const chosen = popularityResults[randomChosen];
        const chosenInfo = await videoService.getVideoInfo(chosen.key);

        return setfeaturedData(chosenInfo);
      } catch {
        return navigate(EM_BREVE_PATH);
      }
    };

    loadAll();
  }, [navigate, profileComplete, profileLoading]);

  return (
    <Index>
      {featuredData ? (
        <div className="page">
          {/* <NavigationVideo /> */}
          <FeaturedVideo item={featuredData} />

          <S.SectionLists>
            {movieList.map(item => (
              <MovieRow key={item.slug} title={item.title} items={item.items} />
            ))}
          </S.SectionLists>
        </div>
      ) : (
        <S.DivLoading>
          <Loading />
        </S.DivLoading>
      )}
    </Index>
  );
}
